import React from 'react';
import BasePage from '@/components/BasePage';
import BaseLayout from '@/components/layouts/BaseLayout';
import BasicLink from '@/Handlers/BasicLink';
import BasicCountryLink from '@/Handlers/BasicCountryLink';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Container, UncontrolledCollapse } from 'reactstrap';

// Translation Higher Order Component
import { translate } from 'react-switch-lang';
const Faq = ({ t }) => {
	return (
		//React.Fragment is used instead of <div> or <> to hide it from source
		<React.Fragment>
			<BaseLayout
				className='cover'
				title={t('faq.title')}
				description={`${t('faq.title1')} ${t('faq.title4')} ${t('faq.title5')}...`}
				keywords={`${t('SEO.keywords_common')} ${t('SEO.keywords_faq')}`}
				canonical='/faq'
			>
				{/* Base Page - Shared component with Container */}
				<BasePage id='faq-page' className='faq-page' role='article'>
					<Container>
						<article>
							<h1 className='page_text font-weight-bold'>{t('faq.title')}</h1>
							<hr className='vaccination-page_hr' />
							<ul>
								<li>
									<h2 id='toggler31' className='page_subtext clickable text-uppercase py-2'>
										{t('faq.title23')}
										<FontAwesomeIcon className='float-right' icon={['fas', 'chevron-down']} />
									</h2>
									<hr className='vaccination-page_hr' />
									<UncontrolledCollapse toggler='#toggler31'>
										<p>{t('faq.text83')}</p>
									</UncontrolledCollapse>
								</li>
								<li>
									<h2 id='toggler32' className='page_subtext clickable text-uppercase py-2'>
										{t('faq.title24')}
										<FontAwesomeIcon className='float-right' icon={['fas', 'chevron-down']} />
									</h2>
									<hr className='vaccination-page_hr' />
									<UncontrolledCollapse toggler='#toggler32'>
										<p>{t('faq.text84')}</p>
									</UncontrolledCollapse>
								</li>
								<li>
									<h2 id='toggler' className='page_subtext clickable text-uppercase py-2'>
										{t('faq.title1')}
										<FontAwesomeIcon className='float-right' icon={['fas', 'chevron-down']} />
									</h2>
									<hr className='vaccination-page_hr' />
									<UncontrolledCollapse toggler='#toggler'>
										<p>
											{t('faq.text1')}
											{t('faq.text2')}
											<BasicLink route='/kids' title={t('faq.child_vaccinations')} />
											{t('faq.and')}
											<BasicLink route='/vaccines' title={t('faq.vaccinations_for_adults')} />
										</p>
										<p>{t('faq.text3')}</p>
									</UncontrolledCollapse>
								</li>
								<li>
									<h2 id='toggler1' className='page_subtext clickable text-uppercase'>
										{t('faq.title2')}
										<FontAwesomeIcon className='float-right' icon={['fas', 'chevron-down']} />
									</h2>
									<hr className='vaccination-page_hr' />
									<UncontrolledCollapse toggler='#toggler1'>
										<p>
											{t('faq.text4')}
											<BasicCountryLink
												className='country_list clickable country_links style_italic'
												inline='inline'
												title={t('faq.country')}
												photo='/images/countries/denmark.webp'
												vaccines={['tetanus', 'diphtheria']}
												country={'Europe.Denmark.title'}
												text1={'Europe.Denmark.text1'}
												text2={'Europe.Denmark.text2'}
												map_lat='55.85064987433714'
												map_long='9.624023437500002'
											/>
											{t('faq.text5')}
										</p>
										<p>{t('faq.text6')}</p>
										<p>{t('faq.text7')}</p>
										<ul>
											<li>
												<h2 id='toggler2' className='page_subtext clickable text-uppercase py-2'>
													{t('faq.planing')}
													<FontAwesomeIcon className='float-right' icon={['fas', 'chevron-down']} />
												</h2>
												<hr className='vaccination-page_hr' />
												<UncontrolledCollapse toggler='#toggler2'>
													<p>{t('faq.text8')}</p>
													<p>{t('faq.text9')}</p>
													<p>{t('faq.text10')}</p>
												</UncontrolledCollapse>
											</li>
											<li>
												<h2 id='toggler3' className='page_subtext clickable text-uppercase py-2'>
													{t('faq.preparation')}
													<FontAwesomeIcon className='float-right' icon={['fas', 'chevron-down']} />
												</h2>
												<hr className='vaccination-page_hr' />
												<UncontrolledCollapse toggler='#toggler3'>
													<p>{t('faq.text11')}</p>
													<p>{t('faq.text12')}</p>
													<p>{t('faq.text13')}</p>
												</UncontrolledCollapse>
											</li>
										</ul>
									</UncontrolledCollapse>
								</li>
								<li>
									<h2 id='toggler4' className='page_subtext clickable text-uppercase py-2'>
										{t('faq.title3')}
										<FontAwesomeIcon className='float-right' icon={['fas', 'chevron-down']} />
									</h2>
									<hr className='vaccination-page_hr' />
									<UncontrolledCollapse toggler='#toggler4'>
										<p>{t('faq.text14')}</p>
									</UncontrolledCollapse>
								</li>
								<li>
									<h2 id='toggler5' className='page_subtext clickable text-uppercase py-2'>
										{t('faq.title4')}
										<FontAwesomeIcon className='float-right' icon={['fas', 'chevron-down']} />
									</h2>
									<hr className='vaccination-page_hr' />
									<UncontrolledCollapse toggler='#toggler5'>
										<p>{t('faq.text15')}</p>
									</UncontrolledCollapse>
								</li>
								<li>
									<h2 id='toggler6' className='page_subtext clickable text-uppercase py-2'>
										{t('faq.title5')}
										<FontAwesomeIcon className='float-right' icon={['fas', 'chevron-down']} />
									</h2>
									<hr className='vaccination-page_hr' />
									<UncontrolledCollapse toggler='#toggler6'>
										<p>
											{t('faq.text16')}
											<BasicLink route='/kids' title={t('faq.child_vaccinations')} />.
											{t('faq.text17')}
										</p>
										<p>{t('faq.text18')}</p>
										<p>{t('faq.text19')}</p>
										<p>{t('faq.text20')}</p>
										<ul>
											<li>
												<h2 id='toggler7' className='page_subtext clickable text-uppercase py-2'>
													{t('faq.card')}
													<FontAwesomeIcon className='float-right' icon={['fas', 'chevron-down']} />
												</h2>
												<hr className='vaccination-page_hr' />
												<UncontrolledCollapse toggler='#toggler7'>
													<p>{t('faq.text21')}</p>
													<p>{t('faq.text22')}</p>
												</UncontrolledCollapse>
											</li>
											<li>
												<h2 id='toggler8' className='page_subtext clickable text-uppercase py-2'>
													{t('faq.cost')}
													<FontAwesomeIcon className='float-right' icon={['fas', 'chevron-down']} />
												</h2>
												<hr className='vaccination-page_hr' />
												<UncontrolledCollapse toggler='#toggler8'>
													<p>
														{t('faq.text23')}
														<BasicLink route='/kids' title={t('faq.child_vaccinations')} />
														{t('faq.text24')}
													</p>
													<p>{t('faq.text25')}</p>
													<p>{t('faq.text26')}</p>
												</UncontrolledCollapse>
											</li>
											<li>
												<h2 id='toggler9' className='page_subtext clickable text-uppercase py-2'>
													{t('faq.find_out')}
													<FontAwesomeIcon className='float-right' icon={['fas', 'chevron-down']} />
												</h2>
												<hr className='vaccination-page_hr' />
												<UncontrolledCollapse toggler='#toggler9'>
													<p>{t('faq.text27')}</p>
													<p>
														{t('faq.text28')}
														<a
															className='country_links inline  style_italic'
															rel='external nofollow noopener'
															href='https://fmk-online.dk/fmk/'
															title='fmk-online.dk'
															target='_blank'
														>
															{t('faq.text29')}
														</a>
													</p>
												</UncontrolledCollapse>
											</li>
										</ul>
									</UncontrolledCollapse>
								</li>
								<li>
									<h2 id='toggler10' className='page_subtext clickable text-uppercase py-2'>
										{t('faq.title6')}
										<FontAwesomeIcon className='float-right' icon={['fas', 'chevron-down']} />
									</h2>
									<hr className='vaccination-page_hr' />
									<UncontrolledCollapse toggler='#toggler10'>
										<p>{t('faq.text30')}</p>
										<p>
											{t('faq.text31')}
											<a
												className='country_links inline style_italic'
												rel='external nofollow noopener'
												href='https://www.sundhed.dk/'
												target='_blank'
												title='sundhed.dk'
											>
												sundhed.dk
											</a>
											.
										</p>
									</UncontrolledCollapse>
								</li>
								<li>
									<h2 id='toggler11' className='page_subtext clickable text-uppercase py-2'>
										{t('faq.title7')}
										<FontAwesomeIcon className='float-right' icon={['fas', 'chevron-down']} />
									</h2>
									<hr className='vaccination-page_hr' />
									<UncontrolledCollapse toggler='#toggler11'>
										<p>{t('faq.text32')}</p>
									</UncontrolledCollapse>
								</li>
								<li>
									<h2 id='toggler12' className='page_subtext clickable text-uppercase py-2'>
										{t('faq.title8')}
										<FontAwesomeIcon className='float-right' icon={['fas', 'chevron-down']} />
									</h2>
									<hr className='vaccination-page_hr' />
									<UncontrolledCollapse toggler='#toggler12'>
										<p>{t('faq.text33')}</p>
									</UncontrolledCollapse>
								</li>
								<li>
									<h2 id='toggler113' className='page_subtext clickable text-uppercase py-2'>
										{t('faq.title9')}
										<FontAwesomeIcon className='float-right' icon={['fas', 'chevron-down']} />
									</h2>
									<hr className='vaccination-page_hr' />
									<UncontrolledCollapse toggler='#toggler113'>
										<p>{t('faq.text34')}</p>
									</UncontrolledCollapse>
								</li>
								<li>
									<h2 id='toggler14' className='page_subtext clickable text-uppercase py-2'>
										{t('faq.title10')}
										<FontAwesomeIcon className='float-right' icon={['fas', 'chevron-down']} />
									</h2>
									<hr className='vaccination-page_hr' />
									<UncontrolledCollapse toggler='#toggler14'>
										<p>{t('faq.text35')}</p>
									</UncontrolledCollapse>
								</li>
								<li>
									<h2 id='toggler15' className='page_subtext clickable text-uppercase py-2'>
										{t('faq.title11')}
										<FontAwesomeIcon className='float-right' icon={['fas', 'chevron-down']} />
									</h2>
									<hr className='vaccination-page_hr' />
									<UncontrolledCollapse toggler='#toggler15'>
										<p>
											<span>
												{t('faq.text36')}
												<BasicCountryLink
													className='country_list clickable country_links style_italic'
													inline='inline'
													title='vaccinationsanbefalinger'
													photo='/images/countries/denmark.webp'
													vaccines={['tetanus', 'diphtheria']}
													country={'Europe.Denmark.title'}
													text1={'Europe.Denmark.text1'}
													text2={'Europe.Denmark.text2'}
													map_lat='55.85064987433714'
													map_long='9.624023437500002'
												/>
												{t('faq.text37')}
											</span>
										</p>
										<p>{t('faq.text38')}</p>
									</UncontrolledCollapse>
								</li>
								<li>
									<h2 id='toggler16' className='page_subtext clickable text-uppercase py-2'>
										{t('faq.title12')}
										<FontAwesomeIcon className='float-right' icon={['fas', 'chevron-down']} />
									</h2>
									<hr className='vaccination-page_hr' />
									<UncontrolledCollapse toggler='#toggler16'>
										<p>
											{t('faq.text39')}
											<BasicLink route='/kids' title={t('faq.child_vaccinations')} /> program.{' '}
											{t('faq.text40')}
										</p>
										<p>{t('faq.text41')}</p>
									</UncontrolledCollapse>
								</li>
								<li>
									<h2 id='toggler17' className='page_subtext clickable text-uppercase py-2'>
										{t('faq.title13')}
										<FontAwesomeIcon className='float-right' icon={['fas', 'chevron-down']} />
									</h2>
									<hr className='vaccination-page_hr' />
									<UncontrolledCollapse toggler='#toggler17'>
										<p>{t('faq.text42')}</p>
									</UncontrolledCollapse>
								</li>
								<li>
									<h2 id='toggler18' className='page_subtext clickable text-uppercase py-2'>
										{t('faq.title14')}
										<FontAwesomeIcon className='float-right' icon={['fas', 'chevron-down']} />
									</h2>
									<hr className='vaccination-page_hr' />
									<UncontrolledCollapse toggler='#toggler18'>
										<p>{t('faq.text43')}</p>
										<p>{t('faq.text44')}</p>
										<p>{t('faq.text45')}</p>
									</UncontrolledCollapse>
								</li>
								<li>
									<h2 id='toggler19' className='page_subtext clickable text-uppercase py-2'>
										{t('faq.title15')}
										<FontAwesomeIcon className='float-right' icon={['fas', 'chevron-down']} />
									</h2>
									<hr className='vaccination-page_hr' />
									<UncontrolledCollapse toggler='#toggler19'>
										<p>{t('faq.text46')}</p>
										<p>{t('faq.text47')}</p>
										<p>{t('faq.text48')}</p>
									</UncontrolledCollapse>
								</li>
								<li>
									<h2 id='toggler20' className='page_subtext clickable text-uppercase py-2'>
										{t('faq.title16')}
										<FontAwesomeIcon className='float-right' icon={['fas', 'chevron-down']} />
									</h2>
									<hr className='vaccination-page_hr' />
									<UncontrolledCollapse toggler='#toggler20'>
										<p>
											{t('faq.text49')}
											<BasicLink route='/kids' title={t('faq.child_vaccinations')} /> program
											{t('faq.text50')}
										</p>
										<p>{t('faq.text51')}</p>
										<p>
											{t('faq.text52')}
											<BasicCountryLink
												className='country_list clickable country_links style_italic'
												inline='inline'
												title={t('faq.country')}
												photo='/images/countries/denmark.webp'
												vaccines={['tetanus', 'diphtheria']}
												country={'Europe.Denmark.title'}
												text1={'Europe.Denmark.text1'}
												text2={'Europe.Denmark.text2'}
												map_lat='55.85064987433714'
												map_long='9.624023437500002'
											/>
										</p>
										<p>{t('faq.text53')}</p>
										<ul>
											<li>
												<h2 id='toggler21' className='page_subtext clickable text-uppercase py-2'>
													{t('faq.text54')}
													<FontAwesomeIcon className='float-right' icon={['fas', 'chevron-down']} />
												</h2>
												<hr className='vaccination-page_hr' />
												<UncontrolledCollapse toggler='#toggler21'>
													<p>{t('faq.text55')}</p>
												</UncontrolledCollapse>
											</li>
										</ul>
									</UncontrolledCollapse>
								</li>
								<li>
									<h2 id='toggler22' className='page_subtext clickable text-uppercase py-2'>
										{t('faq.title17')}
										<FontAwesomeIcon className='float-right' icon={['fas', 'chevron-down']} />
									</h2>
									<hr className='vaccination-page_hr' />
									<UncontrolledCollapse toggler='#toggler22'>
										<p>{t('faq.text56')}</p>
										<p>{t('faq.text57')}</p>
									</UncontrolledCollapse>
								</li>
								<li>
									<h2 id='toggler23' className='page_subtext clickable text-uppercase py-2'>
										{t('faq.title18')}
										<FontAwesomeIcon className='float-right' icon={['fas', 'chevron-down']} />
									</h2>
									<hr className='vaccination-page_hr' />
									<UncontrolledCollapse toggler='#toggler23'>
										<p>{t('faq.text58')}</p>
										<p>{t('faq.text59')}</p>
										<p>
											{t('faq.text60')}
											<BasicCountryLink
												className='country_list clickable country_links style_italic'
												inline='inline'
												title={t('faq.country')}
												photo='/images/countries/denmark.webp'
												vaccines={['tetanus', 'diphtheria']}
												country={'Europe.Denmark.title'}
												text1={'Europe.Denmark.text1'}
												text2={'Europe.Denmark.text2'}
												map_lat='55.85064987433714'
												map_long='9.624023437500002'
											/>
											{t('faq.text61')}
										</p>
									</UncontrolledCollapse>
								</li>
								<li>
									<h2 id='toggler24' className='page_subtext clickable text-uppercase py-2'>
										{t('faq.title19')}
										<FontAwesomeIcon className='float-right' icon={['fas', 'chevron-down']} />
									</h2>
									<hr className='vaccination-page_hr' />
									<UncontrolledCollapse toggler='#toggler24'>
										<p>{t('faq.text62')}</p>
										<ul>
											<li>
												<h2 id='toggler25' className='page_subtext clickable text-uppercase py-2'>
													{t('faq.text63')}
													<FontAwesomeIcon className='float-right' icon={['fas', 'chevron-down']} />
												</h2>
												<hr className='vaccination-page_hr' />
												<UncontrolledCollapse toggler='#toggler25'>
													<p>{t('faq.text64')}</p>
												</UncontrolledCollapse>
											</li>
											<li>
												<h2 id='toggler26' className='page_subtext clickable text-uppercase py-2'>
													{t('faq.text65')}
													<FontAwesomeIcon className='float-right' icon={['fas', 'chevron-down']} />
												</h2>
												<hr className='vaccination-page_hr' />
												<UncontrolledCollapse toggler='#toggler26'>
													<p>{t('faq.text66')}</p>
													<p>{t('faq.text67')}</p>
													<p>{t('faq.text68')}</p>
												</UncontrolledCollapse>
											</li>
										</ul>
									</UncontrolledCollapse>
								</li>
								<li>
									<h2 id='toggler27' className='page_subtext clickable text-uppercase py-2'>
										{t('faq.title20')}
										<FontAwesomeIcon className='float-right' icon={['fas', 'chevron-down']} />
									</h2>
									<hr className='vaccination-page_hr' />
									<UncontrolledCollapse toggler='#toggler27'>
										<p>{t('faq.text69')}</p>
										<p>{t('faq.text70')}</p>
										<p>{t('faq.text71')}</p>
										<ul>
											<li>
												<h2 id='toggler28' className='page_subtext clickable text-uppercase py-2'>
													{t('faq.text72')}
													<FontAwesomeIcon className='float-right' icon={['fas', 'chevron-down']} />
												</h2>
												<hr className='vaccination-page_hr' />
												<UncontrolledCollapse toggler='#toggler28'>
													<p>{t('faq.text73')}</p>
													<p>{t('faq.text74')}</p>
													<p>{t('faq.text75')}</p>
												</UncontrolledCollapse>
											</li>
										</ul>
									</UncontrolledCollapse>
								</li>
								<li>
									<h2 id='toggler29' className='page_subtext clickable text-uppercase py-2'>
										{t('faq.title21')}
										<FontAwesomeIcon className='float-right' icon={['fas', 'chevron-down']} />
									</h2>
									<hr className='vaccination-page_hr' />
									<UncontrolledCollapse toggler='#toggler29'>
										<p>
											{t('faq.text76')}&nbsp;Check&nbsp;
											<a
												className='country_links inline style_italic'
												rel='external nofollow noopener'
												href='http://www.borger.dk'
												title='borger.dk'
												target='_blank'
											>
												www.borger.dk
											</a>
											{t('faq.text77')}
										</p>
										<p>{t('faq.text78')}</p>
									</UncontrolledCollapse>
								</li>
							</ul>
						</article>
					</Container>
				</BasePage>
			</BaseLayout>
		</React.Fragment>
	);
};
export default translate(Faq);
